module.exports = __webpack_public_path__ + "img/icon-view-list.fceb2670.svg";